var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84834 17.7794C5.09178 18.2358 4.15841 17.5586 4.35754 16.6978L5.31432 12.5616C5.39779 12.2007 5.27497 11.8233 4.99511 11.5806L1.78498 8.79752C1.11745 8.2188 1.4734 7.1221 2.35356 7.0457L6.59988 6.67709C6.96906 6.64505 7.29024 6.41147 7.43451 6.07014L9.07889 2.17942C9.42303 1.36515 10.577 1.36515 10.9211 2.17941L12.5655 6.07014C12.7098 6.41147 13.0309 6.64505 13.4001 6.67709L17.6464 7.0457C18.5266 7.1221 18.8826 8.2188 18.215 8.79753L15.0049 11.5806C14.725 11.8233 14.6022 12.2007 14.6857 12.5616L15.6425 16.6978C15.8416 17.5586 14.9082 18.2358 14.1517 17.7794L10.5165 15.5866C10.1988 15.3949 9.80116 15.3949 9.48347 15.5866L5.84834 17.7794Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fef593f73d7b2007fa3d4c055fa77aa2.svg";
export { ForwardRef as ReactComponent };